<div [formGroup]="form" class="w-full">
    <!-- ===================== SS ===================== -->
    <div *ngIf="tipoScambio === 'SS'" class="iv-rows">
        <div class="iv-row">
            <label>Ago destro</label>
            <app-segmented-select [options]="opzioniStatoUsura" formControlName="usuraTelaioAd" palette="state3"></app-segmented-select>
        </div>
        <div class="iv-row">
            <label>Contrago destro</label>
            <app-segmented-select [options]="opzioniStatoUsura" formControlName="usuraTelaioCd" palette="state3"></app-segmented-select>
        </div>
        <div class="iv-row">
            <label>Ago sinistro</label>
            <app-segmented-select [options]="opzioniStatoUsura" formControlName="usuraTelaioAs" palette="state3"></app-segmented-select>
        </div>
        <div class="iv-row">
            <label>Contrago sinistro</label>
            <app-segmented-select [options]="opzioniStatoUsura" formControlName="usuraTelaioCs" palette="state3"></app-segmented-select>
        </div>
        <div class="iv-row">
            <label>Cuore</label>
            <app-segmented-select [options]="opzioniStatoUsura" formControlName="usuraTelaioCuore" palette="state3"></app-segmented-select>
        </div>
    </div>

    <!-- ===================== SD ===================== -->
    <div *ngIf="tipoScambio === 'SD'" class="iv-fieldsets">
        <div>
            <div class="iv-subgroup-title">Telaio 1</div>
            <div class="iv-rows">
                <div class="iv-row" *ngFor="let field of [{ label: 'Ago destro', name: 'usuraAgot1Destro' }, { label: 'Contrago destro', name: 'usuraContrAgot1Destro' }, { label: 'Ago sinistro', name: 'usuraAgot1Sinistro' }, { label: 'Contrago sinistro', name: 'usuraContrAgot1Sinistro' }]">
                    <label>{{ field.label }}</label>
                    <app-segmented-select [options]="opzioniStatoUsura" [formControlName]="field.name" palette="state3"></app-segmented-select>
                </div>
            </div>
        </div>

        <div>
            <div class="iv-subgroup-title">Telaio 2</div>
            <div class="iv-rows">
                <div class="iv-row" *ngFor="let field of [{ label: 'Ago destro', name: 'usuraAgot2Destro' }, { label: 'Contrago destro', name: 'usuraContrAgot2Destro' }, { label: 'Ago sinistro', name: 'usuraAgot2Sinistro' }, { label: 'Contrago sinistro', name: 'usuraContrAgot2Sinistro' }]">
                    <label>{{ field.label }}</label>
                    <app-segmented-select [options]="opzioniStatoUsura" [formControlName]="field.name" palette="state3"></app-segmented-select>
                </div>
            </div>
        </div>

        <div>
            <div class="iv-subgroup-title">Cuori</div>
            <div class="iv-rows">
                <div class="iv-row" *ngFor="let field of [{ label: 'Cuore 1', name: 'usuraCuore1' }, { label: 'Cuore 2', name: 'usuraCuore2' }, { label: 'Cuore 3', name: 'usuraCuore3' }]">
                    <label>{{ field.label }}</label>
                    <app-segmented-select [options]="opzioniStatoUsura" [formControlName]="field.name" palette="state3"></app-segmented-select>
                </div>
            </div>
        </div>
    </div>

    <!-- ===================== SI ===================== -->
    <div *ngIf="tipoScambio === 'SI'" class="iv-fieldsets">
        <div *ngFor="let telaio of [1, 2, 3, 4]">
            <div class="iv-subgroup-title">Telaio {{ telaio }}</div>
            <div class="iv-rows">
                <div class="iv-row" *ngFor="let field of [{ label: 'Ago destro', name: 'usuraAgot' + telaio + 'Destro' }, { label: 'Contrago destro', name: 'usuraContrAgot' + telaio + 'Destro' }, { label: 'Ago sinistro', name: 'usuraAgot' + telaio + 'Sinistro' }, { label: 'Contrago sinistro', name: 'usuraContrAgot' + telaio + 'Sinistro' }, { label: 'Cuore', name: 'usuraCuoret' + telaio }]">
                    <label>{{ field.label }}</label>
                    <app-segmented-select [options]="opzioniStatoUsura" [formControlName]="field.name" palette="state3"></app-segmented-select>
                </div>
            </div>
        </div>
    </div>
</div>
